import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import _ from 'lodash';
import { env } from 'process';
import { Ejecutivo } from 'src/app/global/interfaces/ejecutivo';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { ACTIONS, DialogData } from 'src/app/global/models/dialog/dialog-data';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { environment } from 'src/environments/environment';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { GoToPaso3ServiceVM } from 'src/app/view-model/services/go-to-paso3.service';

@Component({
  selector: 'dialog-ci-validation',
  templateUrl: './ci-validation.component.html',
  styleUrls: ['./ci-validation.component.scss']
})
export class CiValidationComponent {

  constructor(
    public dialogRef: MatDialogRef<CiValidationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authVmService: AuthVMService,
    private storage: LocalStorageService,
    private carroService: CarroComprasService,
    private tagM: TagManagerService,
    private dialogService: DialogService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private inputErrorService: InputErrorService,
    private sessionService: SessionService,
      private stepperService: StepperServiceVM,
      private goToPaso3Service: GoToPaso3ServiceVM
  ) { }

  validacionCheck = false;
  loading = false;
  processing = false;
  product: Product;
  isPersonaNatural = true;
  clickTimeout = null;
  isMobile = null;
  ejecutivo: Ejecutivo;
  urlTerminos = environment.redirections.urlTerminos;
  urlPrivacidad = environment.redirections.urlPrivacidad;

  @Output() nextStep: EventEmitter<any> = new EventEmitter();

  dataPersonaNaturalRetoma: FormGroup = null;

  public messageRescatarDataError = {
    txtSerie: [
      { type: 'required', message: step1Messages.REQUIRED_SERIE_MESSAGE },
      { type: 'serieLength', message: step1Messages.INVALID_SERIE_MESSAGE },
      {
        type: 'invalidSerieOfRut',
        message: step1Messages.INVALID_SERIE_OF_RUT
      }
    ],
    txtRut: [
      { type: 'required', message: step1Messages.REQUIRED_RUT_MESSAGE },
      { type: 'dniInvalid', message: step1Messages.INVALID_RUT_MESSAGE }
    ],
    txtEmail: [
      { type: 'required', message: step1Messages.REQUIRED_EMAIL_MESSAGE },
      { type: 'emailInvalid', message: step1Messages.REQUIRED_EMAIL_MESSAGE }
    ]
  };

  async ngOnInit(): Promise<void> {
    this.authVmService.initCaptcha();
    this.dataPersonaNaturalRetoma = this.authVmService.createForm();
    this.dataPersonaNaturalRetoma.patchValue({
      autorizacion: true,
      autorizacion2: true
    });
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.getEjecutivoData();
    this.getRutForValidation();
  }

  getEjecutivoData() {
    this.ejecutivo = this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo : this.sessionService.getEjecutivo();
    if(this.ejecutivo){
      if(this.sessionService.ejecutivo != null){
        this.dataPersonaNaturalRetoma.patchValue({
          txtEjecutivo: this.sessionService.ejecutivo.id
        });
      }
    }
  }
  getRutForValidation(){
    if(this.data.rut){
        this.dataPersonaNaturalRetoma.patchValue({
          txtRut: this.data.rut
        });
        /** Deshabilitamos la edición del rut */
        this.dataPersonaNaturalRetoma.get('txtRut').disable();
    }
  }

  get rutControl(): FormControl {
    return this.dataPersonaNaturalRetoma.get('txtRut') as FormControl;
  }

  get serieControl(): FormControl {
    return this.dataPersonaNaturalRetoma.get('txtSerie') as FormControl;
  }

  get authControl(): FormControl {
    return this.dataPersonaNaturalRetoma.get('autorizacion') as FormControl;
  }

  get ejecutivoControl(): FormControl {
    return this.dataPersonaNaturalRetoma.get('txtEjecutivo') as FormControl;
  }

  get authControl2(): FormControl {
    return this.dataPersonaNaturalRetoma.get('autorizacion2') as FormControl;
  }

  async onSubmit(): Promise<void> {

    let authResponse = null;
    try {
      this.loading = true;
      authResponse = await this.authVmService.auth(this.dataPersonaNaturalRetoma, this.isMobile);
      if (_.get(authResponse, 'indicador', '') === 'OK') {
        this.processing = false;
        this.save();
        this.tagM.logDL_completa_datos();
      }
    } catch (exception) {
      this.tagM.logError('Paso 1', _.get(exception, 'error.mensaje.titulo', ''), _.get(exception, 'error.message', ''));
      let respuesta: any;
      if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'se le han agotado los intentos')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
      } else {
        console.error(exception);
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
      }
      respuesta.afterClosed().subscribe((resp) => {
        if (resp.action === 'OK') {
          return;
        }
      });

    } finally {
      this.loading = false;
      this.processing = false;
      this.onCloseClick()
    }
  }

  Continuar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {     
        if(this.data.preventDefaultSubmit){
            this.dialogRef.close({
              action: ACTIONS.OK,
              data: this.dataPersonaNaturalRetoma
            });
            return;
        }
        this.onSubmit();
      }, 100);
    }

  }

  save() {
    const paso_1: Paso1 = {
      run: this.rutControl.value,
      ci: String(this.serieControl.value).toUpperCase(),
      currentIsPersonaNatural: this.isPersonaNatural
    };
    this.verificarPaso();
    //this.storage.setPaso1(paso_1);
    //this.storage.setCurrentPage(_.get(env, 'localStorage.PASO_2', ''));
    //this.productVm.cargarEnCarro(products);
    //this.carroService.changePaso('P_1');
    //this.carroService.changeRetoma(true);
  }

   private async verificarPaso() {
    const resp = await this.goToPaso3Service.goToPaso3();

    if (this.rutControl.value >= 50000000) {
      this.isPersonaNatural = false;
    } else {
      this.isPersonaNatural = true;
    }

    if (resp === 'GOTO_PASO_3') {
      if (this.isPersonaNatural) {
        const paso_1: Paso1 = {
          run: this.rutControl.value,
          ci: String(this.serieControl.value).toUpperCase(),
          currentIsPersonaNatural: this.isPersonaNatural
        };
        this.storage.setPaso1(paso_1);
      }
      this.stepperService.nextStep();
      this.stepperService.nextStep();
    }
  }

  checkInput(campo: string) {
    this.inputErrorService.validarError('P1', this.dataPersonaNaturalRetoma.get(campo));
  }
  
  onCloseClick(): void {
    this.dialogRef.close({
      action: 'CLOSE'
    });
  }

}
